import React, { useEffect, useState, useMemo } from 'react'
import { LinearProgress } from '@material-ui/core'
import { useGlobalContext } from '../../state'
import { getMenu } from '../../utils/configQueries'

import { CustomAccordion } from './CustomAccordion'

import {
  setDataTable,
  setFeatures,
  setFeaturesDataTable,
  sideBarRightVisibilityChanged,
  loadingIssues
} from '../../state'

import { useMapEngine } from '../shared'
import {
  getQueryData,
  getDataTable,
  getDataTableByQuery,
  MAP_ID
} from '../../utils/apiHelper'
import { LAYER_KIND, getOptionsData } from '../../utils/configQueries'

import { useLayer } from '@facility-latam/geoportal-components'

export const Menu = () => {
  const {
    state: { genericLayer, layers },
    dispatch
  } = useGlobalContext()

  const [menu, setMenu] = useState([])
  useEffect(() => {
    const menuData = getMenu()
    setMenu(menuData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const options = useMemo(() => getOptionsData(), [])

  const [data, setData] = useState()
  const [engine] = useMapEngine(MAP_ID)

  useEffect(() => {
    if (engine) {
      layers?.forEach(({ id, kind }, idx) => {
        const idAfter = id
        if (kind === LAYER_KIND.EXTERNAL && idx > 0) {
          const idBefore = layers[idx - 1].id
          engine.moveLayer(idAfter, idBefore)
        }
      })
      const izq = layers
        .filter(
          ({ kind, isVisible }) => kind !== LAYER_KIND.EXTERNAL && isVisible
        )
        .map(({ id }) => id)
      const der = layers
        .filter(
          ({ kind, isVisible }) => kind === LAYER_KIND.EXTERNAL && isVisible
        )
        .map(({ id }) => id)
      if (izq[0] && der[0]) {
        engine.moveLayer(izq[0], der[der.length - 1])
      }
    }
  }, [layers, engine])

  useLayer({
    engine,
    source: {
      id: 'limitLayer',
      type: 'raster',
      tiles: [
        // eslint-disable-next-line max-len
        'https://geoportal.cepal.org/geoserver/ows?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&srs=EPSG:3857&transparent=true&width=256&height=256&layers=geonode:limites_pdi'
      ],
      tileSize: 256
    },
    layer: {
      id: 'limitLayer',
      type: 'raster',
      source: 'limitLayer',
      layout: {
        visibility: 'visible'
      },
      paint: {}
    }
  })

  const [setLayersByQuery] = useLayer({
    engine,
    layer: {
      id: 'genericLayer',
      type: 'circle',
      source: 'genericLayer',
      paint: {
        'circle-color': 'red',
        'circle-radius': ['interpolate', ['linear'], ['zoom'], 5, 3, 8, 5]
      }
    }
  })

  useEffect(() => {
    if (data) {
      setLayersByQuery(data)
      engine.moveLayer('limitLayer')
      engine.moveLayer('genericLayer', 'limitLayer')
    }
  }, [data, engine, setLayersByQuery])

  useEffect(() => {
    if (engine) {
      engine.setLayoutProperty(
        'genericLayer',
        'visibility',
        genericLayer.id ? 'visible' : 'none'
      )

      engine.setPaintProperty(
        'genericLayer',
        'circle-color',
        genericLayer?.color
      )

      if (prop && value) {
        engine.setPaintProperty('genericLayer', prop, value)
      }

      // get geojson from query api
      const query = options.find(({ id }) => id === genericLayer?.id)?.query
      const queryRedmine = options.find(
        ({ id }) => id === genericLayer?.id
      )?.queryRedmine

      const {
        projectType,
        country,
        priority,
        features: subjects,
        style: { prop, value }
      } = genericLayer

      const fetchData = async ({ query, queryRedmine, subjects }) => {
        if (!query) {
          return dispatch(setDataTable({ dataTable: [] }))
        }
        const geojsonData = await getQueryData({ query })

        const features =
          geojsonData?.features?.filter(({ properties }) => {
            const isValidProject =
              projectType.length &&
              (projectType === 'null' ||
                (projectType === 'true' && properties.origen_pdi === 't' && properties.cooperacion !== 't') ||
                (projectType === 'false' && properties.origen_pdi !== 't' && properties.cooperacion !== 't') ||
                (projectType === 'cooperation' && properties.cooperacion === 't') ||
                  (projectType === 'trifinio' && properties.trifinio === 't')
                  )

            const isValidCountry =
              country === 'pdi' || properties[`pais_${country}`] === 't'

            const isValidPriority =
              priority === 'null' ||
              (priority === '1' && properties.prioridad === 't') ||
              (priority === '2' && properties.prioridad === 'n') ||
              (priority === '!1' && properties.prioridad !== 't')

            return isValidProject && isValidCountry && isValidPriority
          }) ?? []

        const dataFormat = {
          features,
          type: 'FeatureCollection'
        }
        setData(dataFormat)

        queryRedmine &&
          (await getDataTable({ queryRedmine }).then((data) => {
            const filterData = data
              .filter(({ custom_fields }) =>
                custom_fields.some(
                  ({ id, value }) =>                  
                    id === 43 &&
                    projectType.length &&
                    (['null', "cooperation"].includes(projectType) ||
                    (projectType === 'trifinio' && value === 'trifinio') ||
                      (projectType === 'true' && value === '1') ||
                      (projectType === 'false' && value !== '1' && value !== '3')                      
                    )
                )
              )
              .filter(({ custom_fields }) =>
                custom_fields.some(
                  ({ id, value }) =>
                    id === 46 &&
                    projectType.length &&
                    (['null', "true", "false","trifinio"].includes(projectType) ||
                      (projectType === 'cooperation' && value.length)
                    )
                )
              )
              .filter(({ custom_fields }) =>
                custom_fields.some(
                  ({ id, value }) =>
                    id === 44 &&
                    (value.includes(country.toUpperCase()) || country === 'pdi')
                )
              )
              .filter(
                ({ custom_fields }) =>
                  priority === 'null' ||
                  custom_fields.some(
                    ({ id, value }) =>
                      id === 45 &&
                      ((priority === '1' && value === '1') ||
                      (priority === '2' && value === '2') ||
                        (priority === '!1' && value !== '1'))
                  )
              )
            return dispatch(setDataTable({ dataTable: filterData }))
          }))
        dispatch(loadingIssues({ isLoading: false }))

        subjects.length > 0 &&
          (await getDataTableByQuery({ subjects }).then((data) =>
            dispatch(setFeaturesDataTable({ dataTable: data }))
          ))
      }

      fetchData({ query, queryRedmine, subjects })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [engine, genericLayer, options])

  useEffect(() => {
    if (engine) {
      engine.on('click', ({ point }) => {
        const features = engine
          .queryRenderedFeatures(point)
          .map(({ properties: { id_proy } }) => id_proy)
        if (features.length > 0 && features[0]) {
          dispatch(
            sideBarRightVisibilityChanged({
              isOpen: true,
              selectedType: 'featuresDataTable'
            })
          )
          dispatch(setFeatures({ features }))
        } else {
          dispatch(
            sideBarRightVisibilityChanged({
              selectedType: 'dataTable'
            })
          )
        }
      })

      engine.on('mouseenter', 'genericLayer', () => {
        engine.getCanvas().style.cursor = 'pointer'
      })
      engine.on('mouseleave', 'genericLayer', () => {
        engine.getCanvas().style.cursor = ''
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [engine])

  return (
    <>
      {!menu.length ? (
        <LinearProgress />
      ) : (
        menu.map(
          (
            {
              id,
              submenu,
              areaId,
              name,
              render,
              type,
              icon,
              arrowIcon,
              children
            },
            idx
          ) => (
            <CustomAccordion
              key={id || idx}
              id={id}
              areaId={areaId}
              arrowIcon={arrowIcon}
              icon={icon}
              name={name}
              submenu={submenu}
              render={render}
              type={type}
            >
              {children}
            </CustomAccordion>
          )
        )
      )}
    </>
  )
}
